
import {
  ContentCopy as CopyIcon,
  Lock as LockIcon,
  Visibility,
  VisibilityOff,
} from '@mui/icons-material';
import {
  Alert,
  Box,
  IconButton,
  InputAdornment,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import { useContext, useState } from 'react';
import { AuthContext } from '../utils/AuthContext';
// https://portal.servodesk.com
// https://myOrgName?..servodesk.com
const AccessToken = () => {
  const {
    myOrgName,
    setMyOrgName,
    token,
    setToken,
    tenantCode,
    setTenantCode,
    baseUrl,
    setBaseUrl,
  } = useContext(AuthContext);

  const [visible, setVisible] = useState({
    token: false,
    tenantCode: false,
    myOrgName: false,
    baseUrl: false,
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const toggleVisibility = (key) => {
    setVisible(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const showSnackbar = (message, severity) =>
    setSnackbar({ open: true, message, severity });

  const handleCopy = (text, message) => {
    navigator.clipboard.writeText(text);
    showSnackbar(message, 'info');
  };

  const fields = [
    {
      key: 'token',
      label: 'Token',
      value: token,
      onChange: setToken,
      copyMessage: 'Token copied!',
    },
    {
      key: 'tenantCode',
      label: 'Tenant Code',
      value: tenantCode,
      onChange: setTenantCode,
      copyMessage: 'Tenant code copied!',
    },
    {
      key: 'myOrgName',
      label: 'Subdomain',
      value: myOrgName,
      onChange: setMyOrgName,
      copyMessage: 'Subdomain copied!',
    },
    {
      key: 'baseUrl',
      label: 'Base URL',
      value: baseUrl,
      onChange: setBaseUrl,
      copyMessage: 'Base URL copied!',
    },
  ] ;

  return (
    <Box
      sx={{
        mx: 'auto',
        mt: 3,
        p: 2,
        display: 'flex',
        gap: 3,
        flexWrap: 'wrap',
        borderRadius: 2,
      }}
    >
      {fields.map(({ key, label, value, onChange, copyMessage }) => (
        <TextField
          key={key}
          size="small"
          label={label}
          variant="outlined"
          // fullWidth
          value={value}
          onChange={(e) => onChange(e.target.value)}
          type={visible[key] ? 'text' : 'password'}
          sx={{ width: 'auto'}}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockIcon sx={{ color: 'gray' }} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => toggleVisibility(key)}
                  aria-label={
                    visible[key] ? `Hide ${label}` : `Show ${label}`
                  }
                >
                  {visible[key] ? <VisibilityOff /> : <Visibility />}
                </IconButton>

                <IconButton
                  size="small"
                  onClick={() => handleCopy(value, copyMessage)}
                  disabled={!value}
                  aria-label={`Copy ${label}`}
                >
                  <CopyIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      ))}

      <Typography variant="caption" color="error" sx={{ mt: 1 }}>
        Do not share these credentials publicly. Anyone with access can make API
        requests on your behalf.
      </Typography>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() =>
          setSnackbar(prev => ({ ...prev, open: false }))
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() =>
            setSnackbar(prev => ({ ...prev, open: false }))
          }
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AccessToken;
